import PropTypes from "prop-types";
import React from "react";

const DashboardImage = ({ data }) => {
  const { chartTitle, image, isTitleHidden } = data;
  return (
    <div className="p-2 w-100 h-100">
      {!isTitleHidden && (
        <div className="ql">
          <div className="ql-editor p-0 pb-1" style={{ textAlign: "center" }}>
            <div dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
          </div>
        </div>
      )}

      <div
        style={{
          background: `url('${image?.url}') no-repeat center/contain`,
          height: "100%",
        }}
      ></div>
    </div>
  );
};

export default DashboardImage;

DashboardImage.propTypes = {
  data: PropTypes.object.isRequired,
};
